import type { ApiClient } from '../client';
import { UserSearchResponseSchema, type UserSearchHit } from '../schemas/users';

export async function searchUsersByPhone(
  client: ApiClient,
  phone: string,
): Promise<UserSearchHit[]> {
  const data = await client.get<unknown>(
    `/app_service/panel/v1/users?phone=${encodeURIComponent(phone)}`,
  );
  return UserSearchResponseSchema.parse(data).results;
}
